export default "__VITE_ASSET__88ff9832__"